// Add your JS customizations here
(function() {
  // -----------------------------
  // CONFIG / BREAKPOINTS
  // -----------------------------
  var bps = [320, 576, 992, 1200, 1440, 1920];

  // Section offsets
  var promise, introduction, services, rates, testimonials, contact;

  // Navbar and menu links
  var navbar = document.querySelector('.navbar');
  var menuLinks = {
    37: document.querySelector('#menu-item-37 .nav-link'),
    38: document.querySelector('#menu-item-38 .nav-link'),
    39: document.querySelector('#menu-item-39 .nav-link'),
    40: document.querySelector('#menu-item-40 .nav-link'),
    41: document.querySelector('#menu-item-41 .nav-link'),
    42: document.querySelector('#menu-item-42 .nav-link')
  };

  // -----------------------------
  // HELPERS
  // -----------------------------
  function isBreakPoint(bp) {
    var w = window.innerWidth;
    var min, max;

    for (var i = 0, l = bps.length; i < l; i++) {
      if (bps[i] === bp) {
        min = bps[i - 1] || 0;
        max = bps[i];
        break;
      }
    }
    return w > min && w <= max;
  }

  function getOffsetTop(selector) {
    var el = document.querySelector(selector);
    if (!el) return 0;
    return el.getBoundingClientRect().top + window.pageYOffset;
  }

  function getScrollOffset() {
    if (isBreakPoint(1920)) return 192;
    if (isBreakPoint(1440)) return 177;
    if (isBreakPoint(1200)) return 167;
    if (isBreakPoint(992))  return 164;
    if (isBreakPoint(576))  return 136;
    return 0; // fallback
  }

  function setOffsets() {
    var offset = getScrollOffset();
    promise = getOffsetTop('#promise') - offset;
    introduction = getOffsetTop('#introduction') - offset;
    services = getOffsetTop('#services') - offset;
    rates = getOffsetTop('#rates') - offset;
    testimonials = getOffsetTop('#testimonials') - offset;
    contact = getOffsetTop('#contact') - offset;
  }

  function toggleActive(el, condition) {
    if (!el) return;
    if (condition) el.classList.add('active');
    else el.classList.remove('active');
  }

  function deactivatePrevious(scrollTop) {
    if (scrollTop >= introduction) toggleActive(menuLinks[37], false);
    if (scrollTop >= services) toggleActive(menuLinks[38], false);
    if (scrollTop >= rates) toggleActive(menuLinks[39], false);
    if (scrollTop >= testimonials) toggleActive(menuLinks[40], false);
    if (scrollTop >= contact) toggleActive(menuLinks[41], false);
  }

  // Smooth scroll helper
  function smoothScrollTo(targetSelector) {
    var offset = getScrollOffset();
    var target = document.querySelector(targetSelector);
    if (!target) return;
    var targetPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPos,
      behavior: 'smooth'
    });

    // Update URL hash without jumping
    history.pushState(null, null, targetSelector);
  }

  // -----------------------------
  // MAIN HANDLERS
  // -----------------------------
  function handleScroll() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Navbar scrolled class
    if (scrollTop > 250) navbar.classList.add('scrolled');
    else navbar.classList.remove('scrolled');

    // Section scrollspy
    toggleActive(menuLinks[37], scrollTop >= promise);
    toggleActive(menuLinks[38], scrollTop >= introduction);
    toggleActive(menuLinks[39], scrollTop >= services);
    toggleActive(menuLinks[40], scrollTop >= rates);
    toggleActive(menuLinks[41], scrollTop >= testimonials);
    toggleActive(menuLinks[42], scrollTop >= contact);

    deactivatePrevious(scrollTop);
  }

  function attachSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var hash = this.hash;
        if (!hash) return;
        e.preventDefault();
        smoothScrollTo(hash);
      });
    });
  }

  // -----------------------------
  // DEBOUNCE FOR RESIZE
  // -----------------------------
  function debounce(func, wait) {
    var timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  function init() {
    setOffsets();
    handleScroll();
    attachSmoothScroll();
  }

  // -----------------------------
  // EVENT LISTENERS
  // -----------------------------
  window.addEventListener('load', init);
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', debounce(init, 150));
})();

document.addEventListener('DOMContentLoaded', function() {
	AOS.init({
		duration: 800,   // Animation duration in ms
	});

	document.body.classList.add('active');

  var navbar = document.getElementById('navbarNavDropdown');
  var hamburger = document.querySelector('.hamburger');

  // Listen for Bootstrap's collapse show/hide events
  navbar.addEventListener('show.bs.collapse', function () {
    hamburger.classList.add('is-active');
  });

  navbar.addEventListener('hide.bs.collapse', function () {
    hamburger.classList.remove('is-active');
  });

   var navLinks = navbar.querySelectorAll('.nav-link');
  navLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      // Simulate the toggler button click to close the menu
      var toggler = document.querySelector('[data-bs-toggle="collapse"][data-bs-target="#navbarNavDropdown"]');
      if (toggler && navbar.classList.contains('show')) {
        toggler.click();
      }
    });
  });

	// new SlimSelect({
    // 	select: '#inputID',
    // 	settings: {
	// 	    placeholderText: 'PlaceholderText',
	// 	    showSearch: false,
	//   	}
  	// });
});
